import { Button } from "@progress/kendo-react-buttons";
import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getAlarmsLoadingSelector, getAlarmsLoadingSelectorWithScope, getAlarmsSelector, getAlarmsWithScopeSelector } from "./Slice";
import Spinner from "../Common/Components/spinner";
import { getOptionsSelector, updateChartItemNumber, updateAlarmChartSortOrder, updateMachineTimesVisibility } from "../Common/Slices/optionSlice";
import { useAppDispatch } from "../Core/store.hooks";
import { getMachineTimesLoadingSelector } from "../MachineTimes/slice";

interface MachineFilterProps{
    id:string;
}

const sortOrderOptions = ["Count / Duration", "Count / Duration per shift hours"]
const itemNumberOptions = [10,20,30,40,"All"]

const ChartOptions = (props:MachineFilterProps) =>{
    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [sortOrder, setSortOrder] = useState(sortOrderOptions[0])
    const [itemNumber, setItemNumber] = useState(itemNumberOptions[0])

    const alarms = useSelector(getAlarmsSelector)
    const alarmsWithScope = useSelector(getAlarmsWithScopeSelector)
    const alarmsPending = useSelector(getAlarmsLoadingSelector)
    const alarmsWithScopePending = useSelector(getAlarmsLoadingSelectorWithScope)
    const timesPending = useSelector(getMachineTimesLoadingSelector)
    const options = useSelector(getOptionsSelector)

    const dispatch = useAppDispatch();

    useEffect(()=>{
        setItemNumber(options.chartItemNumber)
    },[])

    useEffect(() => {
        if (alarms != null && alarms != undefined) {
            if (alarms.length > 0 && alarmsWithScope.length > 0 && alarmsPending !== "pending" && alarmsWithScopePending !== "pending" && timesPending !== "pending") {
                setButtonDisabled(false);
            } else {
                setButtonDisabled(true)
            }
        }
    },[alarms,alarmsWithScope,alarmsPending,alarmsWithScopePending,timesPending])

    const handleMachineTimes = () => {
        
        dispatch(updateMachineTimesVisibility(!options.machineTimesVisibility))
    }

    const handleSortOrder = (e:DropDownListChangeEvent) =>{
        setSortOrder(e.target.value)
        dispatch(updateAlarmChartSortOrder(e.target.value))
    }

    const handleItemNumber = (e:DropDownListChangeEvent) =>{
        setItemNumber(e.target.value)
        if(e.target.value === "All"){
            dispatch(updateChartItemNumber(0))
        }else{
            dispatch(updateChartItemNumber(e.target.value))
        }
    }

    return (
        <Fragment>
            <div className=" k-textbox-container metricCombo">
                <label className="k-label">Number Of Items</label>
                <DropDownList
                    data={itemNumberOptions}
                    value={itemNumber}
                    onChange={handleItemNumber}
                />
            </div>

            <div className=" k-textbox-container metricCombo">
                <label className="k-label">Sort Order</label>
                <DropDownList
                    popupSettings={{width:"auto"}}
                    data={sortOrderOptions}
                    value={sortOrder}
                    onChange={handleSortOrder}
                />
            </div>

            {/* <div className="k-textbox-container metricCombo">
                <button
                    style={{
                        height: "30px",
                        marginTop: "2px",
                        borderRadius: "0px",
                    }}
                    className="btn btn-primary btn-md  pp-inlineB"
                    //onClick={() => paramsHandler()}
                >
                    UPDATE
                </button>
            </div> */}

            <div>
                <Button
                style={{width:"95%",marginTop:"5px"}}
                disabled={buttonDisabled}
                onClick={handleMachineTimes}
                >
                {options.machineTimesVisibility ? "Hide Machine Times": "Show Machine Times"}
                {buttonDisabled && <img style={{height:"15px",width:"auto"}} src="assets/img/spinner.gif" />}
                </Button>
            </div>
        </Fragment>
    )
}

export default ChartOptions;